<template>
    <app-wrapper>
        <app-header is-hidden-menu :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Your desired loan amount
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-check-circle text-success text-7xl" />
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">
            <template #title> Your loan is currently pending </template>

            <template #text>
                <template v-if="loan.sub_status === 'mx_connection_denied'">
                    There was an issue when connecting to your bank via our provider. We'll be in contact with next
                    steps.
                </template>
                <template v-else-if="loan.sub_status === 'paystubs_error'">
                    There was an issue when processing your paystubs. 
                    Please provide your paystubs for our support team by address <a :href="$root.app.mailtoSupport">{{ $root.app.support_email }}</a>
                    and provide the loan id in the subject: <strong>{{ loan.id }}</strong>
                </template>
                <template v-else>
                  Your loan is under review. We will reach out if we need more information to process your request. If you have questions or need assistance please contact us at 
                  <a v-if="$root.app?.support_email" :href="$root.app.mailtoSupport">{{ $root.app.support_email }}</a>.

                    <div class="mt-6 shadow-floating bg-white rounded-lg -mb-16 relative z-10">
                        <!---->
                        <div class="flex flex-col md:flex-row md:items-center justify-center">
                            <div class="w-full">
                                <div
                                    class="flex flex-col md:flex-row md:flex-wrap items-center app-header-top p-7 md:py-10 md:px-14"
                                >
                                    <div class="w-full app-header-top">
                                        <div class="w-full flex items-center">
                                            <CreditStrongContent />
                                        </div>
                                    </div>

                                    <div class="w-full text-center">
                                        <button
                                            id="btn-creditstrong"
                                            @click.prevent="offerLoanToCreditStrong()"
                                            class="w-full inline-block bg-green-500 text-white font-medium px-8 py-4 my-6 rounded-full hover:bg-darkgreen no-underline max-w-64 border-1 border-green-400 outline outline-offset-1 outline-green-400 hover:bg-green-600 hover:border-green-600 transition duration-300 ease-in-out"
                                        >
                                            <span v-if="loading">
                                                <i class="fa fa-spinner fa-spin mr-2" />
                                                <span>Processing...</span>
                                            </span>
                                            <span v-else>
                                                <span>GET STARTED NOW</span>
                                            </span>
                                        </button>

                                        <div v-if="error" class="text-red-500 text-sm mt-2">
                                            There was an error. Please try again later.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>
        </app-body>
    </app-wrapper>
</template>

<script>
import CreditStrongContent from "./CreditStrongContent.vue";
import { analytics } from "./../../../analytics";

export default {
    mixins: [
        require("../../../mixins/InteractsWithGtag").default,
        require("../../../mixins/PageViewAnalytics").default
    ],

    
    props: {
      loan: Object,
      creditstrongobject: {
        type: Object,
        default: () => ({}),
        required: false
      }
    },

    components: {
        CreditStrongContent,
    },

    /*mounted() {
        setTimeout(() => {
            window.location = window.location;
        }, 5000);
    },*/

    data() {
        return {
            gTagPageName: "LOAN_PENDING",
            loading: false,
            error: null,
            intervalId: null,
            statusPollId: null,
            statusPollCount: 0,
        };
    },

    methods: {
        offerLoanToCreditStrong() {
            this.loading = true;
            this.error = false;

            analytics.marketPlaceSignUpEvents.clickOfferLoanToCreditStrong({
                loan_id: this.loan.id,
                user_id: this.loan.user_id,
                loan_status: this.loan?.status ?? null,
                event_label: "loan-pending",
            });

            this.$http
                .post(`/account/loans/${this.loan.id}/offer-to-credit-strong`)
                .then((response) => {
                    if (response.data.status === "success") {
                        let url = response.data.url;
                        window.location.href = url;
                    }
                })
                .catch((error) => {
                    this.error = true;
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },

    mounted() {
      this.intervalId = setInterval(() => {
        this.$http.get(`/signup/check-marketplace-status/${this.loan.id}`)
          .then((response) => {
            // The status endpoint no longer rebroadcasts MarketplaceSold, so this page
            // can no longer rely on the global Echo reload to notice a late sale. It has
            // to act on the answer it already asked for: sold means a handoff is waiting,
            // and only a reload can render it.
            if (response.data && response.data.status === 'sold') {
              window.location.reload();
            }
          })
          .catch(() => {});
        this.$http.get(`/signup/check-introxl-status/${this.loan.id}`)
      }, 1 * 60 * 1000);

      this.statusPollId = setInterval(() => {
        this.statusPollCount++;
        if (this.statusPollCount >= 5) {
          clearInterval(this.statusPollId);
          return;
        }
        this.$http.get(`/signup/check-loan-status/${this.loan.id}`).then((response) => {
          if (response.data.status !== this.loan.status) {
            clearInterval(this.statusPollId);
            window.location.reload();
          }
        });
      }, 3000);
    },
  
    beforeDestroy() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      if (this.statusPollId) {
        clearInterval(this.statusPollId);
      }
    },
};
</script>
